import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const sfMissionBayOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'san-francisco',
  neighborhoodSlug: 'mission-bay',
  neighborhoodDisplayName: 'Mission Bay',
  metroDisplayName: 'San Francisco',
  totalCodiClientsInNeighborhood: 1,
  whereFromStreetsToLandmark: 'from the buildings along 3rd St and King St to the clusters near Chase Center',
  whereTeamStreets: '3rd St, King St, Berry St',
  clientDescriptor: 'around 125 people software startup near 3rd St',
  counts: {
    managedCleaningOffices: 1,
    managedPantryOffices: 1,
    managedInternetOffices: 1,
    managedFurnitureOffices: 1,
    managedOfficeAssistantOffices: 1,
    managedDeepCleaningOffices: 1,
    managedCarpetCleaningOffices: 1,
    managedWindowCleaningOffices: 1,
    managedGlassCleaningOffices: 1,
    managedWasteRecyclingOffices: 1,
    managedPantryInventoryOffices: 1,
    managedCoffeeServiceOffices: 1,
    managedWaterServiceOffices: 1,
    managedTeamLunchOffices: 1,
    managedBreakfastCateringOffices: 1,
    managedIndividualMealsOffices: 1,
    managedAdHocCateringOffices: 1,
    managedHappyHourOffices: 1,
    managedConferenceRoomAvOffices: 1,
    managedNetworkInstallationOffices: 1,
    managedNetworkManagementOffices: 1,
    managedCableManagementOffices: 1,
    managedRoomBookingOffices: 1,
    managedPrintingSetupOffices: 1,
    managedInteriorDesignOffices: 1,
    managedOfficeMuralsOffices: 1,
    managedOfficePaintingOffices: 1,
    managedGlassFrostingOffices: 1,
    managedOfficeSignageOffices: 1,
    managedCareRoomOffices: 1,
    managedFurnitureAssemblyOffices: 1,
    managedLayoutChangeOffices: 1,
    managedOfficePlantsOffices: 1,
    managedKeylessAccessOffices: 1,
    managedAlarmSystemsOffices: 1,
    managedSecurityCamerasOffices: 1,
    managedKeypadOffices: 1,
    managedLockboxOffices: 1,
    managedVisitorManagementOffices: 1,
    managedBusinessInsuranceOffices: 1,
    managedElectricalServicesOffices: 4,
    managedHvacOffices: 4,
    managedPlumbingOffices: 3,
    managedPestControlOffices: 3,
    managedOfficeMovingOffices: 4,
    managedMountingInstallationOffices: 6
  },
  quotes: {
    cleaning: "I don't want to think about the office. Codi handles the cleaning so I don't have to.",
    pantryRestocking: 'Pantry and packages pull me in every day \u2014 I needed someone on site.',
    internet: 'Codi coordinated the vendor walkthrough and the whole install \u2014 we just showed up.',
    officeAssistant: 'Building staff drop-ins, packages, pantry restock \u2014 it all needs a person on site.',
    officeFurniture: 'We had a whole furniture order and no one to coordinate it. Codi handled everything.',
    deepCleaning: 'Mission Bay buildings have specific access rules. Codi coordinated everything for the deep clean.',
    carpetCleaning:
      'New office space had worn carpets from the previous tenant. Codi had them cleaned before we moved in.',
    windowCleaning: 'Bay views mean window cleaning matters. Codi keeps them clear without any effort from us.',
    glassConferenceRoom: 'Glass conference walls are always getting marked up. Codi handles the weekly wipe-down.',
    wasteRecycling: 'Waste pickup coordination used to fall on the office manager. Now Codi owns it completely.',
    pantryInventory: 'We had no visibility into what was running low until it was already gone. Codi fixed that.',
    coffeeService: 'Coffee machine setup was the first thing we asked Codi to handle. It\u2019s been seamless.',
    waterService: 'Codi set up the filtered water dispenser and restocks it before it runs out. Zero effort from us.',
    teamLunch: 'Mission Bay office, small team \u2014 weekly lunch keeps the culture tight. Codi runs the logistics.',
    breakfastCatering: 'We do breakfast before our Monday all-hands. Codi sources it locally and has it ready on time.',
    individualMeals: 'Daily lunch for our team near Chase Center. Codi handles the order and delivery every day.',
    adHocCatering: 'Investor meetings, client visits \u2014 Codi handles the catering so we can focus on the pitch.',
    happyHour: 'End-of-sprint happy hour is a team tradition. Codi handles the drinks so we can just enjoy it.',
    conferenceRoomAv: 'Our one conference room needed proper A/V. Codi set it up and it has worked perfectly since.',
    networkInstallation: 'New Mission Bay office, blank slate. Codi had the network running before the team arrived.',
    networkManagement: 'Small office, no IT staff. Codi manages the network so we never have to think about it.',
    cableManagement: 'Codi did a full cable cleanup and labeling pass. The server closet finally makes sense.',
    roomBooking: 'One meeting room, three teams trying to use it. Codi deployed a tablet booking system and solved it.',
    printingSetup: 'Codi installed the printer, set up drivers on every laptop, and handles toner replacement.',
    interiorDesign:
      'New Mission Bay office, open floor plan. Codi did the space planning and managed the fit-out end to end.',
    officeMurals:
      'Bay-view office needed something memorable on the main wall. Codi sourced an artist and handled the installation.',
    officePainting:
      'Refreshed the whole office before a funding announcement. Codi ran the painters over a long weekend.',
    glassFrosting: 'Added frosted film to the boardroom glass. Codi handled measurement, material, and installation.',
    officeSignage:
      'New brand identity needed new signage. Codi designed and installed a lobby wall and wayfinding signs.',
    careRoom: 'Parent on the team needed a proper care room. Codi set it up with furniture and privacy in one visit.',
    furnitureAssembly: 'New office, all new furniture. Codi assembled everything the day before we moved in.',
    layoutChange: 'Moved from open floor to hybrid layout. Codi reconfigured the furniture and rerouted all cabling.',
    officePlants: 'Mission Bay has great light for plants. Codi designed the plant layout and handles monthly care.',
    keylessAccess:
      'Mission Bay office, new space \u2014 keyless access was the first thing we asked Codi to set up. Done before move-in.',
    alarmSystems:
      'Codi installed and manages our alarm system. Building coordination and monitoring vendor were both handled.',
    securityCameras:
      'Security cameras at the entry and server area. Codi installed everything and handles the ongoing management.',
    keypads: 'Keypads on the main entry and back door. Codi manages codes and handles replacements when needed.',
    lockboxes: 'Lockbox for cleaning vendors and delivery couriers. Codi set it up and handles access coordination.',
    visitorManagement:
      'We have guest-heavy investor days. Codi deployed a visitor check-in system that handles everything from arrival to badge.',
    businessInsurance:
      'Mission Bay lease requires COI on file. Codi manages our policy and sends certificates to the building on request.',
    electricalServices:
      'Life science office needed additional outlets and dedicated circuits. Codi coordinated a licensed electrician and managed building permits.',
    hvac: 'The HVAC struggled in warm weather. Codi found an HVAC vendor familiar with Mission Bay buildings and now manages the maintenance schedule.',
    plumbing:
      'Lab-adjacent office has specific plumbing needs. Codi coordinates licensed plumbers and manages any building notification requirements.',
    pestControl:
      'New building, preventive pest control from day one. Codi schedules quarterly treatments and keeps compliance documentation on file.',
    officeMoving:
      'Mission Bay to Mission Bay office expansion required precision coordination. Codi managed movers, building access, and setup in one day.',
    mountingInstallation:
      'Large monitors and a presentation screen for the conference room. Codi mounted everything with hidden cable management in one visit.'
  },
  officeAssistant: {},
  metroWideDemandPullquote: 'all'
});
